<template>
    <v-banner app sticky color="red lighten-3" v-if="showSiteNotice">
        Please setup your Payment Method to use any of the features from this page.
        <template v-slot:actions>
            <v-btn to="profile">Setup Payment Method</v-btn>
        </template>
    </v-banner>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'setup-payment-method-banner',
    computed: {
        showSiteNotice(){
            return this.paymentMethodsInit && ! this.hasPaymentMethods && this.isAgent
        },
    }
}
</script>

<style lang="scss" scoped>

</style>